import { grey } from "@mui/material/colors";

const styles = {
  menuItem: {
    borderBottom: `1px solid ${grey[100]}`,
  },
};

export default styles;
